import { message } from 'antd';
import React, { useEffect } from 'react';
import { MembershipUserDataType } from '../store/config';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const TWO_HOURS_IN_MILLISECONDS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds


interface useMembershipInitProps {
  isTranLoaded: boolean;
  isConfigLoaded: boolean;
  isAuthenticated: boolean;
}

const useMembershipInit = ({
  isTranLoaded,
  isConfigLoaded,
  isAuthenticated,
}: useMembershipInitProps) => {
  const { membershipUser, translations: t } = useSelector(
    (data: RootState) => data.config
  );

  useEffect(() => {
    try {
      if (!isTranLoaded || !isConfigLoaded || !isAuthenticated) {
        return;
      }

      if (!membershipUser?.data || !('secret' in membershipUser?.data)) {
        return;
      }
      const membershipUserData = membershipUser.data as MembershipUserDataType;
      const userName = `${membershipUserData.first_name} ${membershipUserData.last_name}`;
      const now = new Date();

      const lastMessageShownString = localStorage.getItem(
        'lastMessageShownTimestamp'
      );

      const showLoginMessage = () => {
        message.success(`${userName} ${t.auth.loginSuccess}`);
        localStorage.setItem('lastMessageShownTimestamp', now.toISOString());
      };

      const shouldShowMessage = () => {
        if (!lastMessageShownString) {
          return true;
        }

        const lastMessageShown = new Date(lastMessageShownString);
        if (isNaN(lastMessageShown.getTime())) {
          return true;
        }

        const timeDifference = now.getTime() - lastMessageShown.getTime();
        return timeDifference >= TWO_HOURS_IN_MILLISECONDS;
      };

      if (shouldShowMessage()) {
        showLoginMessage();
      }
    } catch (error) {
      // ignore
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isAuthenticated,
    isConfigLoaded,
    isTranLoaded,
  ]);
};

export default useMembershipInit;
